import {Component, EventEmitter, Input, Output} from '@angular/core';


declare let $: any;
import * as Highcharts from "highcharts";
import {FisoMathProvider} from "../../providers/fiso-math/fiso-math";
import {LoadingController} from "ionic-angular";
import * as _ from "lodash";

/**
 * Generated class for the SummaryComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'app-summary',
    templateUrl: 'summary.html',
    providers: [FisoMathProvider]
})
export class SummaryComponent {
    @Input() level: any;
    @Input() sub_level: any;
    @Input() board_name: any;

    start_date: any = null;
    end_date: any = null;
    loader: any = null;

    isShowChart = true;

    groups: any = [];

    @Output() onClose = new EventEmitter();

    text: string;

    constructor(public fisoMathProvider: FisoMathProvider,
                public loadingCtrl: LoadingController) {
        console.log('Hello SummaryComponent Component');
        this.text = 'Hello World';

        this.loader = this.loadingCtrl.create({
            content: "Please wait...",
            duration: 3000
        });
        this.loader.present();

        setTimeout(() => {
            $(function () {
                $(".jqueryui-datepicker").datepicker();
            });

            $('#summary_start_date').change(() => {
                this.start_date = $('#summary_start_date').val();
                this.loadChart();
            });

            $('#summary_end_date').change(() => {
                this.end_date = $('#summary_end_date').val();
                this.loadChart();
            });

            this.loadChart();
        }, 1200);
    }

    loadChart() {
        if (this.level === 'soroban' && !this.sub_level) {
            this.sub_level = 'basic';
        }

        const params: any = {
            user_id: window.localStorage.getItem('USER_ID'),
            level: this.level,
            sub_level: this.sub_level,
            board_name: this.board_name
        };

        if (this.start_date) {
            params.start_date = this.start_date;
        }

        if (this.end_date) {
            params.end_date = this.end_date;
        }

        this.fisoMathProvider.summary(params).subscribe((resp: any) => {
            this.loader.dismiss();

            this.groups = resp.items;
            console.log(this.groups);

            $('#summary_start_date').val(resp.start_date);
            $('#summary_end_date').val(resp.end_date);

            // this.drawChart(resp);
        }, err => {
            this.loader.dismiss();
        });
    }

    loadDetail(date, board_name_title) {
        const params: any = {
            user_id: window.localStorage.getItem('USER_ID'),
            level: this.level,
            sub_level: this.sub_level,
            board_name: this.board_name,
            date: date,
            board_name_title: board_name_title
        };

        this.loader = this.loadingCtrl.create({
            content: "Please wait...",
            duration: 3000
        });

        this.loader.present();
        this.fisoMathProvider.summary_detail(params).subscribe((resp: any) => {
            this.loader.dismiss();
            this.groups = resp.items;

        }, err => {
            this.loader.dismiss();
        });
    }

    drawChart(resp) {
        Highcharts.chart('chart_container', {
            chart: {
                type: 'column'
            },
            title: {
                text: 'Thống kê dữ liệu luyện tập của học viên'
            },
            subtitle: {
                text: 'Phần mềm FISO Online'
            },
            xAxis: {
                categories: resp.dates,
                crosshair: true
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'Số câu trả lời (đúng)'
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b>{point.y:.0f}</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true
            },
            plotOptions: {
                series: {
                    allowPointSelect: true,
                    point: {
                        events: {
                            select: (e: any) => {
                                this.isShowChart = false;
                                this.loadDetail(e.target.category, e.target.series.name);
                            }
                        }
                    }
                },
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0
                }
            },
            series: resp.data
        });
    }

    close() {
        this.onClose.emit();
    }

    countItems(group: any = {}, is_correct = '1') {
        group.items = group.items || [];

        let items = _.filter(group.items, o => {
            return parseInt(o.is_correct) === parseInt(is_correct);
        });
        items = items || [];

        return items.length || 0;
    }

    percentage(group: any) {
        if (!group.items || !group.items.length) {
            return 0;
        }

        const countCorrect = this.countItems(group, '1');
        group.game_config.number_of_questions = parseInt(group.game_config.number_of_questions);
        group.game_config.number_of_questions = group.game_config.number_of_questions || 1;
        return (countCorrect / group.game_config.number_of_questions) * 100;
    }

    calToku(group: any) {
        const countCorrect = this.countItems(group, '1');
        const countInCorrect = this.countItems(group, '0');
        const result = countCorrect - countInCorrect;

        return result > 0 ? `+${result}` : `${result}`;
    }
}



// WEBPACK FOOTER //
// ./src/components/summary/summary.ts